import { IconProps } from "models"

const HeaderWave: React.FC<IconProps> = ({
	className = "",
	style = null,
	width = "1920",
	height = "230",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1920 230"
			className={className}
			style={style}
			width={width}
			height={height}
			aria-hidden="true"
		>
			<path
				d="M0 228.27c16.09 1.056 33.332-3.179 51.782-14 176.437-103.484 155.02-99.837 651.112-154.1 496.093-54.264 486.69 126.453 793.563 91.028C1729.849 124.255 1867.472 71.36 1920 47.573v-49.34H0z"
				opacity=".1"
				fill="var(--primaryColor)"
			/>
			<path
				d="M0 140.259c32.388 26.637 67.397 40.083 103.313 28.917 146.382-45.509 43.772 9.318 215.074-85.93s1043.283 67.693 1370.062 40.177c132.362-11.146 199.047-33.968 231.551-57.178V-1.767H0z"
				opacity=".3"
				fill="var(--primaryColor)"
			/>
		</svg>
	)
}

export default HeaderWave
